(function () {
  var openClass = 'drawer-open';

  function hydrateImages(root) {
    if (!root) return;
    root.querySelectorAll('img[data-src]').forEach(function (img) {
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
    });
  }

  function openDrawer() {
    hydrateImages(document.getElementById('CartDrawer'));
    document.body.classList.add(openClass);
  }
  function closeDrawer() { document.body.classList.remove(openClass); }

  function refreshDrawer(open) {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?sections=cart-drawer' : '/?sections=cart-drawer')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var tmp = document.createElement('div');
        tmp.innerHTML = data['cart-drawer'];
        var fresh = tmp.querySelector('#CartDrawer');
        var current = document.getElementById('CartDrawer');
        if (fresh && current) current.replaceWith(fresh);
        hydrateImages(document.getElementById('CartDrawer'));
        if (open) openDrawer();
      })
      .then(updateBadge);
  }

  function updateBadge() {
    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-badge').forEach(function (b) {
          b.textContent = cart.item_count;
        });
      });
  }

  // Cart mutations always go through /cart/update.js so a parent line and its linked
  // embroidery lines move together: removing a parent removes its children, and changing
  // a parent's quantity scales each child line to match.
  function changeQty(key, quantity) {
    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var updates = {};
        updates[key] = quantity;
        var parent = null;
        cart.items.forEach(function (it) { if (it.key === key) parent = it; });
        var isParent = parent && !(parent.properties && parent.properties._for);
        if (isParent) {
          var prevQty = parent.quantity || 1;
          cart.items.forEach(function (it) {
            if (!it.properties || it.properties._for !== key) return;
            if (quantity === 0) {
              updates[it.key] = 0;
            } else {
              var perSet = Math.max(1, Math.round(it.quantity / prevQty));
              updates[it.key] = perSet * quantity;
            }
          });
        }
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .then(function (res) {
        if (res && !res.ok) throw new Error('cart update failed');
        return refreshDrawer(true);
      })
      .catch(function () { return refreshDrawer(true); });
  }

  document.addEventListener('click', function (e) {
    document.querySelectorAll('details.pdp-dd[open], details.country-dd[open]').forEach(function (dd) {
      if (!dd.contains(e.target)) dd.removeAttribute('open');
    });

    if (e.target.closest('[data-menu-open]')) {
      hydrateImages(document.getElementById('MenuDrawer'));
      document.body.classList.toggle('menu-open');
      if (document.body.classList.contains('menu-open')) {
        requestAnimationFrame(function () {
          var hdr = document.querySelector('.site-header');
          if (!hdr) return;
          var bottom = hdr.getBoundingClientRect().bottom;
          document.documentElement.style.setProperty('--header-h', Math.max(0, Math.round(bottom)) + 'px');
        });
      }
      return;
    }
    if (e.target.closest('[data-menu-close]')) {
      document.body.classList.remove('menu-open');
    }
    // Country rows also switch to the market's language via the hidden locale_code input
    var localeRow = e.target.closest('.country-row[data-locale]');
    if (localeRow) {
      var localeForm = localeRow.closest('form');
      var localeInput = localeForm && localeForm.querySelector('[data-country-locale-input]');
      if (localeInput) localeInput.value = localeRow.dataset.locale;
    }

    if (e.target.closest('[data-country-open]')) {
      hydrateImages(document.getElementById('CountryDrawer'));
      document.body.classList.add('country-open');
      return;
    }
    if (e.target.closest('[data-country-close]')) {
      document.body.classList.remove('country-open');
      return;
    }

    var openEl = e.target.closest('[data-cart-open]');
    if (openEl) { e.preventDefault(); openDrawer(); return; }

    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }

    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      var next = parseInt(qtyBtn.dataset.current, 10) + parseInt(qtyBtn.dataset.qtyChange, 10);
      changeQty(qtyBtn.dataset.key, Math.max(0, next));
      return;
    }

    var removeBtn = e.target.closest('[data-qty-set]');
    if (removeBtn) {
      changeQty(removeBtn.dataset.key, parseInt(removeBtn.dataset.qtySet, 10));
    }
  });

  function openLightbox(images, index) {
    var I = window.I18N || {};
    var lb = document.createElement('div');
    lb.className = 'lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.innerHTML =
      '<button type="button" class="lightbox-close" aria-label="' + (I.close || 'Luk') + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      (images.length > 1 ? '<button type="button" class="lightbox-prev" aria-label="' + (I.prev || 'Forrige') + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5 8 12l7 7"/></svg></button>' : '') +
      '<img class="lightbox-img" src="' + images[index] + '" alt="">' +
      (images.length > 1 ? '<button type="button" class="lightbox-next" aria-label="' + (I.next || 'Næste') + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 5 7 7-7 7"/></svg></button>' : '');
    document.body.appendChild(lb);
    document.body.classList.add('lightbox-open');
    var i = index;
    function show(n) {
      i = (n + images.length) % images.length;
      lb.querySelector('.lightbox-img').src = images[i];
    }
    function close() {
      document.removeEventListener('keydown', onKey);
      lb.remove();
      document.body.classList.remove('lightbox-open');
    }
    function onKey(e) {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft' && images.length > 1) show(i - 1);
      if (e.key === 'ArrowRight' && images.length > 1) show(i + 1);
    }
    lb.addEventListener('click', function (e) {
      if (e.target.closest('.lightbox-prev')) { show(i - 1); return; }
      if (e.target.closest('.lightbox-next')) { show(i + 1); return; }
      if (e.target.closest('.lightbox-close') || e.target === lb) close();
    });
    document.addEventListener('keydown', onKey);
  }

  function galleryOpen(img) {
    var imgs = Array.prototype.slice.call(document.querySelectorAll('.pdp-img img'));
    var srcs = imgs.map(function (el) { return el.currentSrc || el.src; });
    openLightbox(srcs, imgs.indexOf(img));
  }

  document.addEventListener('click', function (e) {
    var img = e.target.closest('.pdp-img img');
    if (img) galleryOpen(img);
  });

  // Keyboard access to the zoom view
  document.querySelectorAll('.pdp-img img').forEach(function (img) {
    img.tabIndex = 0;
    img.setAttribute('role', 'button');
    img.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        galleryOpen(img);
      }
    });
  });

  // PDP gallery arrows: scroll one image at a time, hide when at either end.
  (function () {
    var gallery = document.querySelector('.pdp-gallery');
    var prev = document.querySelector('[data-gallery-prev]');
    var next = document.querySelector('[data-gallery-next]');
    if (!gallery || !prev || !next) return;
    function step() {
      var first = gallery.querySelector('.pdp-img');
      return first ? first.getBoundingClientRect().width + 2 : gallery.clientWidth / 2;
    }
    function sync() {
      var max = gallery.scrollWidth - gallery.clientWidth - 2;
      prev.hidden = gallery.scrollLeft <= 2;
      next.hidden = gallery.scrollLeft >= max;
    }
    prev.addEventListener('click', function () { gallery.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { gallery.scrollBy({ left: step(), behavior: 'smooth' }); });
    gallery.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  })();

  // Sticky mobile buy bar: appears once the real buy button has scrolled out of view.
  (function () {
    var bar = document.querySelector('[data-pdp-sticky]');
    var buy = document.querySelector('.pdp-buy');
    if (!bar || !buy) return;
    // visible only once the buy button has been scrolled past (above the viewport) -
    // not while it is still below the fold on load
    var ticking = false;
    function updateSticky() {
      ticking = false;
      bar.classList.toggle('is-visible', buy.getBoundingClientRect().bottom < 0);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(updateSticky); }
    }, { passive: true });
    updateSticky();
    bar.addEventListener('click', function (e) {
      if (!e.target.closest('[data-sticky-buy]')) return;
      var nameField = document.getElementById('broderi-navn');
      // Personalization is required, send the shopper to the field rather than guessing a name.
      if (nameField && !nameField.value.trim()) {
        nameField.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { nameField.focus(); }, 400);
        if (nameField.reportValidity) nameField.reportValidity();
        return;
      }
      buy.click();
    });
  })();

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer();
      document.body.classList.remove('country-open');
      document.body.classList.remove('menu-open');
      return;
    }
    if (e.key !== 'Tab') return;
    var overlay = activeOverlay();
    if (!overlay) return;
    var f = focusables(overlay);
    if (!f.length) return;
    var first = f[0];
    var last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || !overlay.contains(document.activeElement))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && (document.activeElement === last || !overlay.contains(document.activeElement))) {
      e.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('change', function (e) {
    if (!e.target.classList || !e.target.classList.contains('addon-check')) return;
    var form = e.target.closest('form');
    if (!form) return;
    var totalEl = form.querySelector('.pdp-addon-total');
    if (!totalEl) return;
    var count = form.querySelectorAll('.addon-check:checked').length;
    var priceCents = parseInt(form.dataset.addonPrice || '5000', 10);
    var I = window.I18N || {};
    var money = function (cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'da', { style: 'currency', currency: I.currency || 'DKK' }).format(cents / 100);
      } catch (err) {
        return (cents / 100).toFixed(2) + ' ' + (I.currency || 'DKK');
      }
    };
    var ddLabel = form.querySelector('.pdp-dd-label');
    if (ddLabel) ddLabel.textContent = count ? count + ' ' + (I.selected || 'valgt') : (I.choose || 'Vælg broderier');
    var buyPrice = form.querySelector('.pdp-buy-price');
    var basePrice = parseInt(form.dataset.basePrice || '0', 10);
    if (buyPrice && basePrice) {
      buyPrice.textContent = money(basePrice + count * priceCents);
    }
    totalEl.hidden = count === 0;
    var pattern = (count === 1 ? I.addonOne : I.addonOther) || '+ [amount] for [count] broderi' + (count === 1 ? '' : 'er');
    totalEl.textContent = pattern
      .replace('[amount]', money(count * priceCents))
      .replace('[count]', count);
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.name || t.name !== 'id' || t.type !== 'radio' || !t.closest('.pdp')) return;
    var form = t.closest('form');
    if (!form) return;
    if (t.dataset.price) form.dataset.basePrice = t.dataset.price;
    var nameEl = document.querySelector('[data-fabric-name]');
    if (nameEl && t.dataset.title) nameEl.textContent = t.dataset.title;
    var slide = document.querySelector('[data-fabric-slide]');
    if (slide && t.dataset.image) {
      slide.src = t.dataset.image;
      slide.alt = t.dataset.title || '';
      var slideWrap = slide.closest('.pdp-img');
      slideWrap.hidden = false;
      slideWrap.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }
    var I = window.I18N || {};
    var money = function (cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'da', { style: 'currency', currency: I.currency || 'DKK' }).format(cents / 100);
      } catch (err) {
        return (cents / 100).toFixed(2) + ' ' + (I.currency || 'DKK');
      }
    };
    var base = parseInt(form.dataset.basePrice || '0', 10);
    if (!base) return;
    var count = form.querySelectorAll('.addon-check:checked').length;
    var priceCents = parseInt(form.dataset.addonPrice || '5000', 10);
    var buyPrice = form.querySelector('.pdp-buy-price');
    if (buyPrice) buyPrice.textContent = money(base + count * priceCents);
    var sticky = document.querySelector('.pdp-sticky-price');
    if (sticky) sticky.textContent = money(base);
  });

  document.addEventListener('click', function (e) {
    var modal = document.querySelector('[data-fabric-modal]');
    if (!modal) return;
    if (e.target.closest('[data-fabric-zoom]')) {
      var checked = document.querySelector('.pdp form input[name="id"]:checked');
      if (!checked || !checked.dataset.image) return;
      modal.querySelector('[data-fabric-modal-img]').src = checked.dataset.image;
      modal.querySelector('[data-fabric-modal-img]').alt = checked.dataset.title || '';
      modal.querySelector('[data-fabric-modal-name]').textContent = checked.dataset.title || '';
      modal.hidden = false;
      document.documentElement.classList.add('fabric-modal-open');
    } else if (e.target.closest('[data-fabric-close]')) {
      modal.hidden = true;
      document.documentElement.classList.remove('fabric-modal-open');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var modal = document.querySelector('[data-fabric-modal]');
    if (modal && !modal.hidden) {
      modal.hidden = true;
      document.documentElement.classList.remove('fabric-modal-open');
    }
  });

  // Occasion hero: live name preview, fabric switch, CTA carries the name to the PDP
  (function () {
    var input = document.querySelector('[data-ohero-input]');
    if (!input) return;
    var nameEl = document.querySelector('[data-ohero-name]');
    var canvas = document.querySelector('[data-ohero-canvas]');
    var cta = document.querySelector('[data-ohero-cta]');
    var placeholder = input.placeholder;
    input.addEventListener('input', function () {
      var v = input.value.trim();
      if (nameEl) nameEl.textContent = v || placeholder;
      if (cta) cta.href = cta.dataset.baseUrl + (v ? '?navn=' + encodeURIComponent(v) : '');
    });
    document.querySelectorAll('[data-ohero-fabric]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (canvas) canvas.style.backgroundImage = "url('" + btn.dataset.image + "')";
        document.querySelectorAll('[data-ohero-fabric]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  })();

  // PDP: prefill the name field when arriving from an occasion hero link
  (function () {
    var field = document.getElementById('broderi-navn');
    if (!field || field.value) return;
    var navn = new URLSearchParams(location.search).get('navn');
    if (navn) field.value = navn.slice(0, 20);
  })();

  function showFormError(form) {
    var I = window.I18N || {};
    var el = form.querySelector('.pdp-form-error');
    if (!el) {
      el = document.createElement('p');
      el.className = 'pdp-form-error';
      el.setAttribute('role', 'alert');
      form.appendChild(el);
    }
    el.textContent = I.addonError || 'Broderierne kunne ikke tilføjes. Prøv igen i kurven.';
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    // Two-step add: parent line first, then one 50 kr add-on line per chosen motif.
    // Once the parent is in the cart we must never re-post the form, that would double-charge it.
    var parentAdded = false;
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function (added) {
        parentAdded = true;
        var addonId = parseInt(form.dataset.addonVariant, 10);
        var checks = form.querySelectorAll('.addon-check:checked');
        if (!checks.length) return;
        if (!addonId) throw new Error('addon unavailable');
        var items = Array.prototype.map.call(checks, function (c) {
          return { id: addonId, quantity: 1, properties: { 'Motiv': c.dataset.motif, '_for': added.key } };
        });
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (res) {
          if (!res.ok) throw new Error('addon add failed');
        });
      })
      .then(function () { return refreshDrawer(true); })
      .catch(function () {
        if (parentAdded) {
          // Parent is already in the cart: never re-submit. Surface the add-on failure instead.
          showFormError(form);
          return refreshDrawer(true);
        }
        form.submit();
      })
      .finally(function () { if (btn) btn.disabled = false; });
  });
})();

// Consent keeper: Shopify resets a domain's consent cookies when visitors arrive via a
// cross-domain market switch (dk <-> com), so the cookie banner re-asks people who already
// answered. Persist the answer in localStorage and re-apply it through the official
// Customer Privacy API whenever the cookies have been wiped.
(function () {
  var KEY = 'lillelin-consent';
  document.addEventListener('visitorConsentCollected', function (e) {
    var d = e && e.detail;
    if (!d) return;
    try {
      localStorage.setItem(KEY, JSON.stringify({
        analytics: !!d.analyticsAllowed,
        marketing: !!d.marketingAllowed,
        preferences: !!d.preferencesAllowed,
        sale_of_data: !!d.saleOfDataAllowed
      }));
    } catch (err) { /* storage unavailable */ }
  });
  var saved = null;
  try { saved = JSON.parse(localStorage.getItem(KEY)); } catch (err) { /* ignore */ }
  if (!saved) return;
  if (document.cookie.indexOf('_shopify_analytics=') !== -1) return; // consent cookies intact
  if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
    if (error || !window.Shopify.customerPrivacy) return;
    window.Shopify.customerPrivacy.setTrackingConsent(saved, function () {
      var banner = document.getElementById('shopify-pc__banner');
      if (banner) banner.style.display = 'none';
    });
  });
})();
